import React, { useEffect, useState } from 'react'

// Thrid Party
import { Container, Row, Col, Button, Form, InputGroup, Card, Image, ButtonGroup } from "react-bootstrap";
import { useLazyQuery } from '@apollo/client';
import useReactRouter from "use-react-router";
import _ from 'lodash';

// Icons
import { FaDownload } from "react-icons/fa";


// Constants
import { BG_GRADIENT_NEW } from '../../../constants';
import { GET_ORDERGROUPS_DETAIL } from '../../../graphql/order/query';
import { GET_BANKS } from '../../../graphql/bank/query';
import { convertCurrency, convertCurrentDate, imageRender, numberFormat } from '../../../helpers';

export default function ConfirmPayment() {
   const { match } = useReactRouter();

   // Stats
   const [selectedBank, setSelectedBank] = useState({});

   // logs


   // Apollo client hooks
   const [loadPreOrderGroup, { data: preOrderGroup, loading: loadingOrderGroup }] = useLazyQuery(GET_ORDERGROUPS_DETAIL, { fetchPolicy: "network-only" });
   const [loadBankAccount, { data: bankAccountData }] = useLazyQuery(GET_BANKS, { fetchPolicy: "cache-and-network" });

   // Effects
   useEffect(() => {
      newFetchOrderGroup()
   }, [])

   useEffect(() => {
      if (bankAccountData) {
         const _bankActive = bankAccountData?.banks?.data.find((data) => data?.isActiveDefault || data[0]);

         if (_bankActive) {
            setSelectedBank(_bankActive);
         }
      }
   }, [bankAccountData])

   useEffect(() => {
      if (preOrderGroup?.orderGroup?.shop) {
         loadBankAccount({
            variables: {
               where: {
                  shop: preOrderGroup?.orderGroup?.shop?.id,
                  isDeleted: false,
               }
            }
         })
      }
   }, [preOrderGroup])

   // load to get orderGroups
   const newFetchOrderGroup = async () => {
      try {
         if (loadingOrderGroup) return;
         await loadPreOrderGroup({
            variables: {
               where: {
                  id: match?.params?.data,
               }
            }
         })
      } catch (error) {
         console.error("Error fetching order group:", error);
      }
   }

   // Handle select bank
   const onSelectBankActive = (value) => {
      const _selectedBank = bankAccountData?.banks?.data.find((item) => item?.bankAccount === value);
      if (value !== "") {
         setSelectedBank(_selectedBank);
      } else {
         setSelectedBank(bankAccountData?.banks?.data[0]);
      }
   }

   console.log("logs preOrderGroup state: ", preOrderGroup);


   return (
      <React.Fragment>
         <Container className="py-5 m-0 max-width-lg" style={{ maxWidth: 500 }}>
            {/* Header */}
            <div className="d-flex justify-content-center align-items-center flex-column mb-2 p-2">
               <Image
                  src={imageRender(preOrderGroup?.orderGroup?.shop?.image)}
                  alt={preOrderGroup?.orderGroup?.shop?.name}
                  // roundedCircle
                  style={{ width: 80, height: 80 }}
               />
               <h1 className="fs-4 fw-semibold mb-0">{preOrderGroup?.orderGroup?.shop?.name}</h1>
               <p className="text-muted mb-0">{preOrderGroup?.orderGroup?.shop?.phone ?? "xxx-xxx-xxx"}</p>
               <small className="text-muted">{preOrderGroup?.orderGroup?.shop?.address?.village ?? "..."}, {preOrderGroup?.orderGroup?.shop?.address?.district ?? "..."},  {preOrderGroup?.orderGroup?.shop?.address?.province ?? "..."}</small>
            </div>

            {/* Action Buttons */}
            <Row>
               <ButtonGroup aria-label="Basic example">
                  <Button variant="secondary">ຂົນສົ່ງອື່ນໆ</Button>
                  <Button variant="secondary">ຮຸ່ງອາລຸນ, ມີໄຊ</Button>
               </ButtonGroup>
            </Row>

            {/* Customer Information */}
            <Card className="mb-4 p-1 shadow-sm">
               <Card.Body className="p-4">
                  <Row className="mb-3">
                     <Col md={6} className="mb-3 mb-md-0">
                        <Form.Group>
                           <Form.Label className="fw-medium" style={{ opacity: 0.5 }}>ຊື່ຜູ້ຊື້ {isreQuired}</Form.Label>
                           <Form.Control defaultValue="PPa To Lex" />
                        </Form.Group>
                     </Col>
                     <Col md={6}>
                        <Form.Group>
                           <Form.Label className="fw-medium" style={{ opacity: 0.5 }}>ເບີໂທ {isreQuired}</Form.Label>
                           <InputGroup>
                              <InputGroup.Text id="basic-addon" style={{ marginLeft: 0 }}>020 || 030</InputGroup.Text>
                              <Form.Control
                                 aria-label="phonne"
                                 aria-describedby="basic-addon"

                              />
                           </InputGroup>
                        </Form.Group>
                     </Col>
                  </Row>
                  <Form.Group className="mb-3">
                     <Form.Label className="fw-medium" style={{ opacity: 0.5 }}>ທີ່ຢູ່ຂົນສົ່ງ ພິມຊື່ຂົນສົ່ງ ສາຂາ ໃຫ້ລະອຽດ {isreQuired}</Form.Label>
                     <Form.Control as="textarea" rows={3} />
                  </Form.Group>
               </Card.Body>
            </Card>

            {/* QR Code Section */}
            <Card className="mb-4 shadow-sm overflow-hidden">
               <div className="p-4 text-white" style={{ background: BG_GRADIENT_NEW }}>
                  <Form.Group>
                     {/* <Form.Label className="fw-medium" style={{ opacity: 0.5 }}>ເລືອກບັນຊີ່ອື່ນ</Form.Label> */}
                     <Form.Select onChange={(e) => onSelectBankActive(e?.target?.value)}>
                        <option value="">ເລືອກບັນຊີ່ອື່ນ</option>
                        {bankAccountData?.banks?.data?.map((item) => (
                           <option key={item?.id} selected={selectedBank?.bankAccount === item?.bankAccount} value={item?.bankAccount}>{item?.bankName}</option>
                        ))}
                     </Form.Select>
                  </Form.Group>
                  <Row className="mb-3">
                     <Col>
                        {/* <p className="fw-medium mb-0">ຊື່ບັນຊີ</p> */}
                        <p className="fs-6 fw-bold mb-0">{selectedBank?.bankUser}</p>
                     </Col>
                     <Col className="text-end">
                        <p className="fw-medium mb-0">ເລກບັນຊີ</p>
                        <p>{selectedBank?.bankAccount}</p>
                     </Col>
                  </Row>

                  <div className="text-center py-3 d-flex gap-2">
                     <div className="bg-white p-3 rounded d-inline-block">
                        <Image
                           src={imageRender(selectedBank?.image)}
                           alt="QR Code"
                           width={160}
                           height={300}
                        />
                     </div>
                     {/* <div className="bg-white p-3 rounded d-inline-block">
                        <Image
                           src={imageRender(selectedBank?.image)}
                           alt="QR Code"
                           width={130}
                           height={200}
                        />
                     </div> */}
                  </div>

               </div>
               <Card.Footer className="text-center p-0">
                  <Button variant="link" className="text-muted w-100 py-3">
                     <FaDownload className="me-2" size={14} />
                     <span>ບັນທຶກລົງ</span>
                  </Button>
               </Card.Footer>
            </Card>

            {/* Order Summary */}
            <Card className="mb-4 shadow-sm">
               <Card.Header className="text-center py-3">
                  <h2 className="fs-5 fw-semibold mb-0">{preOrderGroup?.orderGroup?.code}</h2>
               </Card.Header>
               <Card.Body>
                  <Row className="mb-3 g-3">
                     <Col xs={6} className="text-muted">ສະຖານະ</Col>
                     <Col xs={6} className="text-end text-danger">ຍັງບໍ່ຊຳລະເງິນ</Col>

                     {/* <Col xs={3} className="text-muted">ເລກບິນທີ</Col>
                     <Col xs={9} className="text-end">{preOrderGroup?.orderGroup?.code}</Col> */}

                     <Col xs={6} className="text-muted">ວັນທີສັ່ງຊື້</Col>
                     <Col xs={6} className="text-end">{convertCurrentDate(preOrderGroup?.orderGroup?.createdAt ?? "")}</Col>
                  </Row>

                  <hr className="my-3" />

                  <div className="mb-3">
                     {/* Product Item 1 */}
                     {!_.isEmpty(preOrderGroup?.orderGroup?.orders) && preOrderGroup?.orderGroup?.orders.map((item, index) => (
                        <div key={index} className="d-flex align-items-center mb-3">
                           <div className="bg-white p-1 rounded me-3" style={{ width: 48, height: 48 }}>
                              <Image
                                 src={imageRender(item?.liveStock?.stock?.image ?? item?.stock?.image)}
                                 alt={item?.productName}
                                 width={30}
                                 height={30}
                                 className="mx-auto d-block"
                              />
                           </div>
                           <div className="flex-grow-1">
                              <p className="fw-medium mb-0">{item?.productName} ({item?.message})</p>
                              <small className="text-muted">{numberFormat(item?.price ?? 0)} {convertCurrency(item?.currency ?? "ກີບ")} x{item?.amount}</small>
                           </div>
                           <div className="text-end">
                              <p className="fw-medium mb-0">{numberFormat(item?.totalPrice ?? 0)} {convertCurrency(item?.currency ?? "ກີບ")}</p>
                           </div>
                        </div>
                     ))}

                  </div>

                  <hr className="my-3" />

                  <div>
                     <div className="d-flex justify-content-between mb-2">
                        <p className="text-muted mb-0">ຄ່າບໍລິການ</p>
                        <p className="mb-0">0 ກີບ</p>
                     </div>
                     <div className="d-flex justify-content-between fw-bold">
                        <p className="mb-0">ເງິນທີ່ຕ້ອງຈ່າຍທັງໝົດ</p>
                        <p className="mb-0">{numberFormat(preOrderGroup?.orderGroup?.totalPrice ?? 0)}{convertCurrency(preOrderGroup?.orderGroup?.currency ?? "ກີບ")}</p>
                     </div>
                  </div>
               </Card.Body>
            </Card>

            {/* Final Action Button */}
            <Button size="lg" className="w-100 py-3 fs-5" style={{ background: BG_GRADIENT_NEW, border: 'none' }}>ປິດບັນຫາການສຳລະ</Button>
         </Container>
      </React.Fragment>
   )
}

const isreQuired = (
   <small style={{ color: "red" }}>*</small>
)
